// src/services/authService.js
const API_BASE_URL = process.env.REACT_APP_API_URL || '';

export const loginWithGoogle = () => {
  // FIX: Add '/auth' so Nginx sends this to Python
  window.location.href = `${API_BASE_URL}/auth/login/google`;
};

export const logoutUser = () => {
  // FIX: Add '/auth' here too
  window.location.href = `${API_BASE_URL}/auth/logout`;
};


export const getCurrentUser = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/api/me`, {
      method: 'GET',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'include', // Important: sends the cookie!
    });

    if (response.status === 200) {
      return await response.json();
    }
    return null;
  } catch (error) {
    console.error("Auth check failed", error);
    return null;
  }
};